import { createSelector } from 'reselect';
import { get, some } from 'lodash';
import {
    aggDataBySenderIdSelector,
    aggResultsIsLoadingSelector,
} from '../../common/selectors/aggregate-results-selectors';
import { rightPaneAttributesSelector } from '../../common/selectors/right-pane-selectors';

export const unverifiedSendersDataIsLoadingSelector = createSelector(
    aggResultsIsLoadingSelector, ( aggResultsIsLoading ) => aggResultsIsLoading
);

export const selectedUnverifiedSenderIdSelector = createSelector(
    rightPaneAttributesSelector, ( attributes ) => get( attributes, 'senderId', '' )
);

export const unverifiedSendersSelector = createSelector(
    aggDataBySenderIdSelector,
    ( senders ) => {
        const formattedSenders = Object.keys( senders ).map( ( id ) => senders[id] )
            .reduce( ( accumulator, sender ) => {
                return filterNonVerifiedSenders( accumulator, sender );
            }, [] )
            .sort( ( s1, s2 ) =>  s2.domainsCount - s1.domainsCount );
        return formattedSenders;
    }
);

function filterNonVerifiedSenders( senderList, { name, id, countsByDomain } ){
    const notVerifiedOnAnyDomains = !some( countsByDomain,[ 'verified', true] );
    if( notVerifiedOnAnyDomains && id ){
        senderList.push( {
            domainsCount: Object.keys( countsByDomain ).length,
            name: name,
            senderId: id,
        } );
    }
    return senderList;
}

